import { TemplateData, TemplateParams } from '.';

const calendarEventRegistrationQueued = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'calendar-events',
  email: {
    buttonEnabled: true,
    buttonLink: '{{eventUrl}}',
    buttonText: messages.eventCalendarEventPage,
    content: `
      <p>
        ${messages.calendarEventRegistrationEmailQueued}
        ${messages.calendarEventRegistrationEmailDetails}
      </p>
      <div style="margin-top: 15px;">
        {{eventDetails}}
      </div>`,
    contentAfterButton: messages.emailSignatureText,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.calendarEventRegistrationEmailSubject} {{eventTitle}}`
  },
  placeholders: {
    eventDetails: {
      label: messages.eventCalendarEventDetails,
      description: messages.eventCalendarEventDetailsDescription,
      example: ''
    },
    eventTitle: {
      label: messages.calendarEventTitle,
      example: 'Test event'
    },
    eventUrl: {
      label: messages.calendarEventLink,
      example: `${serverConfig.adminUrl}/calendar/1`
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeCalendarEventRegistrationQueued
});

export default calendarEventRegistrationQueued;
